"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestWrapper = void 0;
var tslib_1 = require("tslib");
var TestWrapper_1 = require("@reactionable/core/lib/tests/TestWrapper");
var react_1 = tslib_1.__importDefault(require("react"));
var UI_1 = require("../UI");
function TestWrapper(props) {
    return react_1.default.createElement(TestWrapper_1.TestWrapper, tslib_1.__assign({ ui: UI_1.useUIContextProviderProps() }, props));
}
exports.TestWrapper = TestWrapper;
//# sourceMappingURL=TestWrapper.js.map